<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      :title="`${l.program.name ? l.program.name + ' - Édition du lot' : 'Édition du lot'}`"
      :subtitle="`${l ? l.ref : ''}`">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <lot-form
          :source-lot="documentEl"
          :source-loading="loading"
          :source-lot-program="lotProgram"
          @submit="updateLot"
          @updateSources="updateSources"></lot-form>
      </div>
    </page-content>
  </div>
</template>

<script>
import LotMixin from './LotMixin'

export default {
  name: 'LotEdit',
  components: {
    LotForm: () => import('@/components/lots/LotForm')
  },
  mixins: [LotMixin],
  data () {
    return {
      isParent: true
    }
  }
}
</script>
